export default __webpack_public_path__ + "static/media/success_badge_icon.798adae2.svg";